import React from 'react';
import TreeSelect from 'antd/lib/tree-select';

const TreeSelectWidget = ({ props, choices, type, initialValue }) => {
  const { TreeNode } = TreeSelect;
  return (
    <TreeSelect
      filterOption
      optionFilterProp="children"
      showSearch
      mode={type === 'MultipleSelect' ? 'multiple' : ''}
      dropdownMatchSelectWidth={false}
      getPopupContainer={(trigger) => trigger.parentNode}
      style={{ width: '100%' }}
      size="large"
      treeCheckable={true}
      {...props}
      treeDefaultExpandAll={true}
      defaultValue={initialValue}
    >
      {choices.map((group) => (
        <TreeNode
          title={group.label}
          key={group.key}
          value={group.value.toString()}
        >
          {group.value.map((item) => (
            <TreeNode
              key={item.key}
              value={item.value.toString()}
              title={item.label}
              className={item.className}
            />
          ))}
        </TreeNode>
      ))}
    </TreeSelect>
  );
};

export default TreeSelectWidget;
